<template>
    <div style="display: flex; flex-direction: column; height: 100%">
      <van-nav-bar
        left-arrow
        title="维修项目选择"
        left-text="返回"
        @click-left="$emit('update:visible', false)">
      </van-nav-bar>
      <div style="background-color:#C4C4C4;width:100%;height:100%;font-size: 12px;">
        <div class="top">
            <div class="positionBtn" v-for="item in partsTypes" :label="item.name" :key="item.code" @click="btnPartsList(item.code)"
            :style="{color:partsCode===item.code?'white':'black',background:partsCode===item.code?'#329DFF':'white'}">{{ item.name }}</div>
            <div>
                <van-radio-group v-model="repairType_">
                    <van-radio name="COMMON">普通</van-radio>
                    <van-radio name="QUICK">快修</van-radio>
                </van-radio-group>
            </div>
        </div>
        <div style="width:96%;margin:0px auto;">
            <div class="determtop" v-if="quick">
                <div style="flex:1.6;"><label style="margin-left:25px;">定损部件</label></div>
                <div class="dTtile" style="width:100px;">油漆幅数</div>
            </div>
            <div class="determtop" v-else>
                <div style="flex:1.6;"><label style="margin-left:25px;">定损部件</label></div>
                <div class="dTtile" style="flex:0.8;">维修类型</div>
                <div class="dTtile" style="flex:0.8;">损伤程度</div>
                <div class="dTtile" style="flex:0.8;">工时/幅数</div>
            </div>
            <div class="determdrow">
                <el-table v-show="!quick" :data="partsMapByType[partsCode]" >
                    <el-table-column show-overflow-tooltip prop="name" min-width="140">
                        <template #default="{ row }">
                            <el-checkbox :disabled="row.fixed" v-model="row.selected" @input="partsSelectChange(row)" style="margin-left:10px;">{{row.name}}</el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column  width="72">
                        <template #default="{ row }">
                            <div v-show="row.selected">
                                <el-checkbox :disabled="row.fixed || (!work.allowSheetMetalProcedure && !work.allowAssemblyProcedure)"
                                    v-model="row.isSheetMetal" @input="sheetMetalChange(row)" size="big" style="height:30px;">钣金
                                </el-checkbox>
                                <el-checkbox :disabled="row.fixed || !work.allowPaintProcedure"
                                    v-model="row.isPaint" @input="paintChange(row)" size="big">喷漆
                                </el-checkbox>
                                <el-checkbox :disabled="row.fixed || !work.allowDisassemblyProcedure"
                                    v-model="row.isDisassembly" @input="disassemblyChange(row)" size="big">拆检
                                </el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="72">
                        <template #default="{ row }">
                            <div style="height:90px;" v-show="row.selected">
                                <div style="height:30px;">
                                    <van-dropdown-menu active-color="#329DFF" style="padding-top: 4px;">
                                        <van-dropdown-item v-model="row.sheetMetalDegree" :options="option1" @change="sheetMetalDegreeChange(row)"/>
                                    </van-dropdown-menu>
                                </div>
                                <div style="height:30px;">
                                    <van-dropdown-menu active-color="#329DFF" style="padding-top: 4px;">
                                        <van-dropdown-item v-model="row.paintDegree" :options="option2" @change="paintDegreeChange(row)"/>
                                    </van-dropdown-menu>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  width="72">
                        <template #default="{ row }">
                            <div style="height:90px;text-align: center;" v-show="row.selected">
                                <div style="height:30px;"><input type="text" class="lossInput" :disabled="row.fixed || !work.allowSheetMetalProcedure" v-model="row.sheetMetalWH" @keyup = "row.sheetMetalWH = row.sheetMetalWH.replace(/[^\d.]/g,'')"></div>
                                <div style="height:30px;"><input type="text" class="lossInput" :disabled="row.fixed || !work.allowSheetMetalProcedure" v-model="row.paintArea" @keyup = "row.paintArea = row.paintArea.replace(/[^\d.]/g,'')"></div>
                                <div style="height:30px;"><input type="text" class="lossInput" :disabled="row.fixed || !work.allowSheetMetalProcedure" v-model="row.disassemblyWH" @keyup = "row.disassemblyWH = row.disassemblyWH.replace(/[^\d.]/g,'')"></div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <el-table :data="partsMapByType[partsCode]" v-show="quick">
                    <el-table-column show-overflow-tooltip prop="name" label="定损部件">
                        <template #default="{ row }">
                            <el-checkbox :disabled="row.fixed" v-model="row.isPaint" @input="partsSelectChange(row)" style="margin-left:10px;">{{row.name}}</el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="油漆幅数" width="100">
                        <template #default="{ row }">
                            <div style="text-align: center;">
                                <input type="text" class="lossInput" :disabled="row.fixed" v-model="row.paintArea" v-show="row.isPaint" @keyup = "row.paintArea = row.paintArea.replace(/[^\d.]/g,'')">
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top:10px;padding: 10px 0px;background: white;border-radius: 10px;">
                <div class="btnConfirm" @click="confirm">确定</div>
            </div>
        </div>
      </div>
    </div>
  </template>

  <script>
    import { NavBar, RadioGroup, Radio, CheckboxGroup, Checkbox, DropdownMenu, DropdownItem } from 'vant'
    import { shareDataMixin } from '@/views/mixins/ShareData'

    export default {
      name: 'WxLossDetermDialog',
      mixins: [shareDataMixin],
      components: {
        [NavBar.name]: NavBar,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem
      },
      props: {
        work: {
          type: Object,
          required: true
        },
        selectedPartsList: {
            type: Array,
            required: true
        },
        repairType: {
            type: String,
            required: true
        }
      },
      data () {
        return {
            repairType_: '1',
            partsMapByType: [],
            partsCode: '',
            loading: false,
            partsMapByTypeList: [],
            partsTypesCode: '', // 选择的分类
            checked: false,
            result: [], // 部位
            result1: [], // 类型
            value1: '0',
            option1: [// 钣金损伤程度
                { text: '请选择', value: null },
                { text: '新件', value: 'NEW' },
                { text: '轻', value: 'LIGHT' },
                { text: '中', value: 'MEDIUM' },
                { text: '重', value: 'HEAVILY' }
            ],
            value2: 0,
            option2: [// 喷漆损伤程度
                { text: '请选择', value: null },
                { text: '新件', value: 'NEW' },
                { text: '局部', value: 'LOCAL' },
                { text: '半喷', value: 'HALF' },
                { text: '全喷', value: 'FULL' }
            ]
        }
      },
      created () {
        console.log(this.selectedPartsList)
        console.log(this.$store.state.data.PARTS_TYPE)
        console.log(this.$store.state.data.Parts)
        this.repairType_ = this.repairType// 初始化选择普通
        this.btnPartsList('DB')// 初始化选择顶部
        this.getNewPartsList()
        var partsList = this.$store.state.data.Parts
        var partsTypes = this.$store.state.data.PARTS_TYPE
        if (!partsTypes || partsTypes.length === 0) return
        if (!partsList) return

        this.partsMapByType = {}

        for (const type of partsTypes) {
          const list = this.partsMapByType[type.code] = []
          list.splice(0, list.length)
          for (const parts of partsList) {
            if (parts.typeCode !== type.code) continue

            // 过滤品牌
            if (parts.brandIds && parts.brandIds.length > 0) {
              if (parts.brandIds.indexOf(this.work.brandModel[0]) === -1) {
                continue
              }
            }
            const selectedPart = this.selectedPartsMap[parts.id]
            const listItem = {
              id: parts.id,
              name: parts.name,
              fixed: selectedPart ? selectedPart.fixed : false,
              sheetMetalDegree: selectedPart ? selectedPart.sheetMetalDegree : null,
              paintDegree: selectedPart ? selectedPart.paintDegree : null,
              isDisassembly: selectedPart ? selectedPart.isDisassembly : false,
              isSheetMetal: selectedPart ? selectedPart.isSheetMetal : false,
              isPaint: selectedPart ? selectedPart.isPaint : false,
              disassemblyWH: selectedPart ? selectedPart.disassemblyWH : 0,
              sheetMetalWH: selectedPart ? selectedPart.sheetMetalWH : 0,
              paintArea: selectedPart ? selectedPart.paintArea : 0,
              assemblyWH: selectedPart ? selectedPart.assemblyWH : 0
            }
            listItem.selected = listItem.isDisassembly || listItem.isSheetMetal || listItem.isPaint
            list.push(listItem)
            // console.log(list)
            // console.log(this.partsMapByType)
          }
        }

        this.$store.dispatch('partsCoe/all').finally(() => {
          this.loading = false
        })
      },
      methods: {
        btnPartsList (code) {
            // this.partsMapByTypeList = []
            // for (var item of this.$store.state.data.Parts) {
            //     if (item.typeCode === code) {
            //         item.checked = false
            //         this.partsMapByTypeList.push(item)
            //     }
            // }
            // console.log(this.partsMapByTypeList)
            this.partsCode = code
        },
        partsSelectChange (parts) {
            const partsCoe = this.partsCoeMap[parts.id]
            if (partsCoe !== undefined) {
                parts.paintArea = partsCoe.paintCoe.LOCAL[0]
            }
            if (!partsCoe) {
                this.$message.warning('该部件没有配置默认系数，请在系数管理页面配置!')
                // this.$alert('该部件没有配置默认系数，请在系数管理页面配置!', {
                //     confirmButtonText: '确定'
                // }).catch(() => {})
                if (this.quick) {
                    parts.isPaint = false
                } else {
                    parts.selected = false
                }
                return
            } else {
                // 默认选中
                parts.isSheetMetal = true
                parts.isPaint = true
                parts.sheetMetalDegree = 'MEDIUM'
                parts.paintDegree = 'FULL'
                if (this.work.allowSheetMetalProcedure) {
                    parts.sheetMetalWH = partsCoe.sheetMetalCoe.MEDIUM[0]
                }
                parts.paintArea = partsCoe.paintCoe.FULL[0]
            }
            if (this.quick) {
                parts.paintArea = partsCoe.quickCoe[0]
            }
        },
        sheetMetalChange (parts) {
            if (!parts.isSheetMetal) {
                parts.sheetMetalDegree = null
                parts.sheetMetalWH = 0
            }
        },
        paintChange (parts) {
            if (!parts.isPaint) {
                parts.paintDegree = null
                parts.paintArea = 0
            }
        },
        disassemblyChange (parts) {
            const partsCoe = this.partsCoeMap[parts.id]
            if (parts.isDisassembly) {
                parts.disassemblyWH = partsCoe.disassemblyCoe[0]
            } else {
                parts.disassemblyWH = 0
            }
        },
        sheetMetalDegreeChange (parts) {
            const partsCoe = this.partsCoeMap[parts.id]
            if (this.work.allowSheetMetalProcedure) {
                parts.sheetMetalWH = partsCoe.sheetMetalCoe[parts.sheetMetalDegree][0]
            }
            if (this.work.allowAssemblyProcedure) {
                parts.assemblyWH = partsCoe.assemblyCoe[0]
            }
            parts.isSheetMetal = true
        },
        paintDegreeChange (parts) {
            const partsCoe = this.partsCoeMap[parts.id]
            parts.paintArea = partsCoe.paintCoe[parts.paintDegree][0]
            parts.isPaint = true
        },
        confirm () {
            debugger
            const partsList = this.getNewPartsList()
            if (!partsList) return

            this.$emit('update:selectedPartsList', {
                repairType: this.repairType_,
                partsList
            })
            this.$emit('update:visible', false)
        },
      getNewPartsList () {
        const retData = []
        for (const type in this.partsMapByType) {
          const partsList = this.partsMapByType[type]
          for (const parts of partsList) {
            if (!this.quick) {
              if (!parts.selected) continue
              if (!parts.isDisassembly && !parts.isSheetMetal && !parts.isPaint) {
                this.$message.warning('请选择【' + parts.name + '】的维修类型！')
                return
              }
              if (parts.isSheetMetal && !parts.sheetMetalDegree) {
                this.$message.warning('请选择【' + parts.name + '】的钣金损伤程度！')
                return
              }
              if (parts.isPaint && !parts.paintDegree) {
                this.$message.warning('请选择【' + parts.name + '】的喷漆损伤程度！')
                return
              }
              const newItem = {
                id: parts.id,
                name: parts.name,
                isDisassembly: parts.isDisassembly,
                isSheetMetal: parts.isSheetMetal,
                isPaint: parts.isPaint,
                disassemblyWH: parts.isDisassembly ? parts.disassemblyWH : 0,
                sheetMetalWH: parts.isSheetMetal ? parts.sheetMetalWH : 0,
                assemblyWH: parts.isSheetMetal ? parts.assemblyWH : 0,
                paintArea: parts.isPaint ? parts.paintArea : 0,
                sheetMetalDegree: parts.isSheetMetal ? parts.sheetMetalDegree : null,
                paintDegree: parts.isPaint ? parts.paintDegree : null
              }
              if (this.isAddParts) {
                newItem.fixed = parts.fixed
              }
              retData.push(newItem)
            } else {
              if (!parts.isPaint) continue

              retData.push({
                id: parts.id,
                name: parts.name,
                isDisassembly: false,
                isSheetMetal: false,
                isPaint: true,
                disassemblyWH: 0,
                sheetMetalWH: 0,
                assemblyWH: 0,
                paintArea: parts.paintArea,
                sheetMetalDegree: null,
                paintDegree: null
              })
            }
          }
        }
        return retData
      }
      },
      computed: {
        quick () {
            return this.repairType_ === 'QUICK'
        },
        selectedPartsMap () {
            const data = {}
            if (this.selectedPartsList !== undefined) {
                for (const parts of this.selectedPartsList) {
                    data[parts.id] = parts
                }
            }
            return data
        },
        partsTypes () {
            return this.$store.state.data.PARTS_TYPE
        },
        partsList () {
            return this.$store.state.data.Parts
        },
        change () {
            return {
                selectedPartsList: this.selectedPartsList,
                partsTypes: this.partsTypes,
                partsList: this.partsList,
                loading: this.loading
            }
        }
      },
      watch: {
        change ({ selectedPartsList, partsTypes, partsList }) {
        if (!partsTypes || partsTypes.length === 0) return
        if (!partsList) return

        this.partsMapByType = {}

        for (const type of partsTypes) {
          const list = this.partsMapByType[type.code] = []
          list.splice(0, list.length)
          for (const parts of partsList) {
            if (parts.typeCode !== type.code) continue

            // 过滤品牌
            if (parts.brandIds && parts.brandIds.length > 0) {
              if (parts.brandIds.indexOf(this.work.brandModel[0]) === -1) {
                continue
              }
            }
            const selectedPart = this.selectedPartsMap[parts.id]
            const listItem = {
              id: parts.id,
              name: parts.name,
              fixed: selectedPart ? selectedPart.fixed : false,
              sheetMetalDegree: selectedPart ? selectedPart.sheetMetalDegree : null,
              paintDegree: selectedPart ? selectedPart.paintDegree : null,
              isDisassembly: selectedPart ? selectedPart.isDisassembly : false,
              isSheetMetal: selectedPart ? selectedPart.isSheetMetal : false,
              isPaint: selectedPart ? selectedPart.isPaint : false,
              disassemblyWH: selectedPart ? selectedPart.disassemblyWH : 0,
              sheetMetalWH: selectedPart ? selectedPart.sheetMetalWH : 0,
              paintArea: selectedPart ? selectedPart.paintArea : 0,
              assemblyWH: selectedPart ? selectedPart.assemblyWH : 0
            }
            listItem.selected = listItem.isDisassembly || listItem.isSheetMetal || listItem.isPaint
            list.push(listItem)
            // console.log(list)
            // console.log(this.partsMapByType)
          }
        }

        this.$store.dispatch('partsCoe/all').finally(() => {
          this.loading = false
        })
        },
        quick (value) {
        if (!value) return
        for (const parts of this.partsMapByType[this.partsCode]) {
          if (parts.isPaint) {
            const partsCoe = this.partsCoeMap[parts.id]
            parts.paintArea = partsCoe.quickCoe[0]
          }
        }
      }
      }
    }
  </script>

  <style lang="scss" scoped>
        .top{
            width: 100%;
            // border: 1px solid white;
            // border-radius: 5px;
            display: flex;
            background-color: white;
            height: 50px;
            align-items: center;
            justify-content: space-around;
        }
        .positionBtn{
            width: 40px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #329DFF;
            border-radius: 10px;
            text-align: center;
        }
        .determtop{
            width: 100%;
            height: 30px;
            border: 1px solid white;
            border-radius: 5px;
            background-color: white;
            margin-top: 5px;
            display: flex;
            align-items: center;
        }
        .determdrow{
            width: 100%;
            height: calc(100vh - 210px);
            overflow-y: auto;
            border: 1px solid white;
            border-radius: 5px;
            background-color: white;
            margin-top: 10px;
        }
        .dTtile{
            text-align: center;
        }
        .Textrow{
            width:100%;
            height: 30px;
            line-height: 30px;
        }
        .lossInput{
            border:1px solid black;
            border-radius: 10px;
            width: 60%;
            height: 20px;
            text-align: center;
            margin-top: 3px;
        }
        /deep/ .van-dropdown-menu__bar{
            width: 100%;
            height: 20px;
            border: 1px solid black;
            border-radius: 5px;
        }
        /deep/ .van-ellipsis{
            font-size: 12px;
        }
        /deep/ .van-dropdown-item--down{
            width: 96%;
            margin: 0px auto;
        }
        /deep/ .el-table__header-wrapper{
            height: 0px;
        }
        /deep/ .cell{
            padding-left: 0px;
            padding-right: 0px;
        }
        /deep/ .el-checkbox{
            height:30px;
            line-height: 30px;
        }
        /deep/ .el-checkbox__label{//多选显示文字大小
            font-size: 12px;
        }
        .btnConfirm{
            width: 100px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border-radius: 10px;
            background-color: #329DFF;
            color: white;
            margin: 0px auto;
            font-size: 16px;
        }

  </style>
